import { type QueryHookOptions, useQuery } from "@apollo/client";
import { CollectionsListQuery } from "../graphql/queries";
import type {
  CollectionsListQueryType,
  CollectionsListQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useCollectionsQuery = (
  options?: QueryHookOptions<
    CollectionsListQueryType,
    CollectionsListQueryVariablesType
  >
) => {
  return useQuery<CollectionsListQueryType, CollectionsListQueryVariablesType>(
    CollectionsListQuery,
    options
  );
};
